// extracted by mini-css-extract-plugin
export var deleteIcon = "_so-5";
export var deleteOption = "_so-3";
export var divider = "_so-2";
export var downloadIcon = "_so-4";
export var drawer = "_so-0";
export var drawerFooter = "_so-6";
export var drawerOpen = "_so-1";
export var highlighted = "_so-7";
export var lighterHighlight = "_so-8";